import { Controller } from "@hotwired/stimulus"

// Handles inline editing for task fields
export default class extends Controller {
  static targets = ["display", "input", "form"]
  static values = { editing: Boolean }

  connect() {
    this.editingValue = false
  }

  edit(event) {
    event.preventDefault()
    this.editingValue = true
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel(event) {
    if (event.key === "Escape") {
      this.editingValue = false
      this.displayTarget.classList.remove("hidden")
      this.inputTarget.classList.add("hidden")
    }
  }

  submit(event) {
    // Submit on Enter for text inputs
    if (event.key === "Enter" && event.target.tagName !== "TEXTAREA") {
      event.preventDefault()
      this.formTarget.requestSubmit()
    }
  }

  blur() {
    // Auto-submit on blur if value changed
    if (this.editingValue) {
      this.formTarget.requestSubmit()
    }
  }
}
